export const States = [
  "Alaska",
  "Alabama",
  "Arkansas",
  "American Samoa",
  "Arizona",
  "California",
  "Colorado",
  "Connecticut",
  "District of Columbia",
  "Delaware",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Iowa",
  "Idaho",
  "Illinois",
  "Indiana",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Massachusetts",
  "Maryland",
  "Maine",
  "Michigan",
  "Minnesota",
  "Missouri",
  "Mississippi",
  "Montana",
  "North Carolina",
  "North Dakota",
  "Nebraska",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "Nevada",
  "New York",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Virginia",
  "Virgin Islands",
  "Vermont",
  "Washington",
  "Wisconsin",
  "West Virginia",
  "Wyoming",
];

// Base URLs from environment variables
export const BASE_URL = import.meta.env.VITE_BASE_URL ;

/**
 * Canonical public marketing origin for ticket/product/share links.
 * Use when the app runs on staging (e.g. idolcodesource) but links must point at production.
 */
export const PUBLIC_SITE_URL = (import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined)?.trim() ?? "";
export const APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL;
export const INSTAGRAM_URL = import.meta.env.VITE_INSTAGRAM_URL ?? "";
export const FACEBOOK_URL = import.meta.env.VITE_FACEBOOK_BASE_URL ?? "";
export const YOUTUBE_URL = import.meta.env.VITE_YOUTUBE_BASE_URL ?? "";
export const TIKTOK_URL = import.meta.env.VITE_TIKTOK_BASE_URL ?? "";
export const LINKEDIN_URL = import.meta.env.VITE_LINKEDIN_BASE_URL ?? "";

// Page Routes
export const PAGE_ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  PRESS: "/press",
  FAQ: "/faq",
  CONTACT: "/contact",
  WORK_WITH_US: "/work-with-us",
  TICKETS: "/tickets",
  GALLERY: "/gallery",
  CART: "/cart",
  COMEDYUO:"/comedyuo",
} as const;

// Full URLs for navigation
export const NAVIGATION_URLS = {
  HOME: `${BASE_URL}${PAGE_ROUTES.HOME}`,
  ABOUT: `${BASE_URL}${PAGE_ROUTES.ABOUT}`,
  PRESS: `${BASE_URL}${PAGE_ROUTES.PRESS}`,
  FAQ: `${BASE_URL}${PAGE_ROUTES.FAQ}`,
  CONTACT: `${BASE_URL}${PAGE_ROUTES.CONTACT}`,
  WORK_WITH_US: `${BASE_URL}${PAGE_ROUTES.WORK_WITH_US}`,
  TICKETS: `${BASE_URL}${PAGE_ROUTES.TICKETS}`,
  GALLERY: `${APP_BASE_URL}${PAGE_ROUTES.GALLERY}`,
  CART: `${BASE_URL}${PAGE_ROUTES.CART}`,
  INSTAGRAM:  `${INSTAGRAM_URL}`,
  INSTACOMEDYUO:`${INSTAGRAM_URL}${PAGE_ROUTES.COMEDYUO}`,
  FACEBOOKCOMEDYUO:`${FACEBOOK_URL}${PAGE_ROUTES.COMEDYUO}`,
  YOUTUBE: `${YOUTUBE_URL}`,
  TIKTOK: `${TIKTOK_URL}`,
  LINKEDIN: `${LINKEDIN_URL}`,
} as const;
export const SHOWTYPES = ["comedy", "magic"];

export function getShowTypeColor(type: string) {
  return type == "comedy" ? "#4063d5" : "#f2aa23ff";
}
